import { searchDataParam } from '../utility/constants';
import { TableColumnsProp } from '../models/tables.model';

export const requiredCommodityKeys = [
  'commodityNumber',
  'hsCode',
  'value',
  'description',
  'countryOfManufacturer',
  'weight',
];

export const defaultBagPagination = {
  paging: {
    fromIndex: 0,
    toIndex: 10,
    sortingOrder: 'desc',
    sortingField: searchDataParam.bagId,
  },
  searchText: '',
};

export const paperSizes = [
  { value: 'Letter', viewValue: 'Letter' },
  { value: 'Legal', viewValue: 'Legal' },
  { value: 'A4', viewValue: 'A4' },
];

export const paperSizesList = {
  Letter: 'Letter',
  Legal: 'Legal',
  A4: 'A4',
};

export const paperSizesWidth = {
  // 20px padding also added for width
  Letter: 856,
  Legal: 871,
  A4: 856,
};

export const NotesHeaders = [
  {
    key: 'note',
    label: 'Note',
    isSelected: true,
    defaultPrintWidth: 200,
  },
  {
    key: 'noteType',
    label: 'Notes Type',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'createdBy',
    label: 'Created By',
    isSelected: true,
    defaultPrintWidth: 180,
  },
  {
    key: 'dateAndTime',
    label: 'Date and Time',
    isSelected: true,
    defaultPrintWidth: 180,
  },
];

export const AttachmentsHeaders = [
  {
    key: 'attachmentType',
    label: 'Type',
    isSelected: true,
    defaultPrintWidth: 170,
  },
  {
    key: 'fileName',
    label: 'File Name',
    isSelected: true,
    defaultPrintWidth: 200,
  },
  {
    key: 'description',
    label: 'Description',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'createdBy',
    label: 'Created By',
    isSelected: true,
    defaultPrintWidth: 170,
  },
  {
    key: 'dateAndTime',
    label: 'Date and Time',
    isSelected: true,
    defaultPrintWidth: 170,
  },
];

export const LookupColumnsConfig = [
  {
    label: 'Country',
    key: 'country',
  },
  {
    label: 'State',
    key: 'state',
  },
  {
    label: 'Origin',
    key: 'name',
  },
  {
    label: 'Destination',
    key: 'name',
  },
  {
    label: 'Actions',
    key: 'action',
  },
];

export const defauthawbPagination = {
  sortingOrder: searchDataParam.desc,
  sortingField: searchDataParam.hawbId,
  fromIndex: 0,
  toIndex: 10,
};

export const ufoShipmentsGridColumnsConfig: TableColumnsProp[] =
  [
    { key: 'hawbExt', label: 'UFO Shipments', isSelected: true },
    { key: 'shipmentCreatedDateAndTime', label: 'Shipment Created Date / Time', isSelected: true },
    { key: 'shipperConsigneeName', label: 'Shipper Name / Consignee Name', isSelected: true },
    { key: 'weight', label: 'Weight (lbs)', isSelected: true },
  ];